import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const LayoutDynamicBox = ({ data, apiData }) => {
  const { chartTitle, dynamicBoxLevels = [], dynamicBoxDefalutBG = "#000", isTitleHidden } = data;
  const [backgroundColor, setBackgroundColor] = useState(dynamicBoxDefalutBG || "");

  useEffect(() => {
    if (!dynamicBoxLevels?.length) {
      setBackgroundColor(dynamicBoxDefalutBG);
    } else if (apiData?.data) {
      const value = apiData?.data?.value || 0;
      let newColor = dynamicBoxDefalutBG;
      const sortValue = [...dynamicBoxLevels]?.sort((a, b) => parseInt(a.level) - parseInt(b.level));
      for (let i = sortValue.length - 1; i >= 0; i--) {
        const { level, color } = sortValue[i];
        if (value >= Number(level)) {
          newColor = color;
          break;
        }
      }
      setBackgroundColor(newColor);
    } else {
      setBackgroundColor(dynamicBoxDefalutBG);
    }
  }, [apiData, dynamicBoxLevels, dynamicBoxDefalutBG]);

  return (
    <div className="p-2 w-100 h-100">
      <div className="mr-1 px-2 py-3 text-center">
        {!isTitleHidden && (
          <div className="ql">
            <div className="ql-editor p-0 pb-1" style={{ textAlign: "center" }}>
              <div dangerouslySetInnerHTML={{ __html: chartTitle }}></div>
            </div>
          </div>
        )}
      </div>
      <div className="px-2 py-3 text-white" style={{ background: backgroundColor, height: "74%" }}></div>
    </div>
  );
};

export default LayoutDynamicBox;

LayoutDynamicBox.propTypes = {
  data: PropTypes.object.isRequired,
  mainDashboard: PropTypes.bool,
  apiData: PropTypes.object,
};
